const theme = {
  default: '#343a40',
};

export default theme;
